module.exports = __webpack_public_path__ + "img/b1.f28c3220.png";